const { branding } = require("../config");
const { getDomain } = require("../helpers/methods");

const getBranding = (url = null) => {
	return new Promise((resolve, reject) => {
		// fetch(branding)
		// 	.then(response => response.json())
		// 	.then(data => {
		// 		const domainName =
		// 			getDomain(url).split(".") && getDomain(url).split(".")[0] ? getDomain(url).split(".")[0] : "sinao";
		// 		const brandName = domainName === "localhost" ? "sinao" : domainName;

		// 		resolve(data[brandName]);
		// 	})

		fetch(`${branding}?domain=${getDomain(url)}`)
			.then(response => response.json())
			.then(data => { resolve(data); })
			.catch(error => reject(error));
	});
};

module.exports = { getBranding };
